// B2C MOCK: https://mock.xiaojukeji.com/project/16099/interface/api

import env from '../config/env';
let mockApi = {};

if (env.isDev) {
  mockApi = {
    // ENTREGA_RULES: 'https://mock.xiaojukeji.com/mock/822/centrega/config/rules',
    // ORDER_LIST:
    //   'https://mock.xiaojukeji.com/mock/16099/entregabusiness/orderList',
    // ADDRESS_SEARCH: 'https://mock.xiaojukeji.com/mock/8358/address/textSearch',
    // ENTREGA_ORDER_CANCEL:
    //   'https://mock.xiaojukeji.com/mock/822/entrega/orderCancel',
    // ENTREGA_ORDER_PRE_CANCEL:
    //   'https://mock.xiaojukeji.com/mock/822/entrega/orderPreCancel',
    // PAY_GETPAYINFO:
    //   'https://mock.xiaojukeji.com/mock/16099/entrega/payMethodList',
    // PROTECT_NUM: 'https://mock.xiaojukeji.com/mock/16099/virtualtel/preCall',
    // BATCH_QUERY_ADDRESS_POI:
    //   'https://mock.xiaojukeji.com/mock/16099/entregabusiness/textListSearch',
    // BILL_INDEX: 'https://mock.xiaojukeji.com/mock/16099/entregabusiness/home',
    // ORDER_DETAIL: 'https://mock.xiaojukeji.com/mock/16099/entrega/orderDetail',
    // COMPUTED_PRICE:
    //   'https://mock.xiaojukeji.com/mock/16099/entregabusiness/billInfo',
    // ORDER_CREATE:
    //   'https://mock.xiaojukeji.com/mock/16099/entregabusiness/createOrder',
    // ORDER_CONTRACT_INFO:
    //   'https://mock.xiaojukeji.com/mock/16099/entregabusiness/getContractOrderInfo',
    // GET_PAY_STATUS:
    //   'https://mock.xiaojukeji.com/mock/16099/gulfstream/pay/v1/didipay/getPayStatus',
    // ADDRESS_LIST: 'https://mock.xiaojukeji.com/mock/16099/entrega/addressList',
    // CHECK_OPEN_TIME:
    //   'https://mock.xiaojukeji.com/mock/16099/entregabusiness/checkOpenTime',
    // GET_TOKEN: 'https://mock.xiaojukeji.com/mock/8358/common/getToken',
    // // 查询账户信息
    // QUERY_ACCOUNT:
    //   'https://mock.xiaojukeji.com/mock/16099/entregabusiness/accountInfo',
    // // 添加账户信息
    // ADD_ACCOUNT:
    //   'https://mock.xiaojukeji.com/mock/16099/entregabusiness/addAccount',
    // // 更新账户信息
    // UPDATE_ACCOUNT:
    //   'https://mock.xiaojukeji.com/mock/16099/entregabusiness/updateAccount',
    // // 获取枚举
    // GET_MENU: 'https://mock.xiaojukeji.com/mock/16099/entregabusiness/enmu',
  };
}

export default mockApi;
